/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratPillarInfo,
    JsonStratPillarInfoFromJSON,
    JsonStratPillarInfoFromJSONTyped,
    JsonStratPillarInfoToJSON,
} from './JsonStratPillarInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonStratPillarInfo
 */
export interface ApiResultOfListOfJsonStratPillarInfo {
    /**
     * 
     * @type {Array<JsonStratPillarInfo>}
     * @memberof ApiResultOfListOfJsonStratPillarInfo
     */
    data?: Array<JsonStratPillarInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratPillarInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonStratPillarInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratPillarInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratPillarInfo
     */
    result?: ApiResultOfListOfJsonStratPillarInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonStratPillarInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonStratPillarInfoFromJSON(json: any): ApiResultOfListOfJsonStratPillarInfo {
    return ApiResultOfListOfJsonStratPillarInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonStratPillarInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonStratPillarInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonStratPillarInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonStratPillarInfoToJSON(value?: ApiResultOfListOfJsonStratPillarInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonStratPillarInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

